export default "/_next/static/fonts/536428ff5b1f066051f66846159a9c46.woff";